require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-basic-javascript-global-vs-local-scope-in-functions.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-basic-javascript-global-vs-local-scope-in-functions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-basic-javascript-global-vs-local-scope-in-functions!./.cache/json/javascript-algorithms-and-data-structures-basic-javascript-global-vs-local-scope-in-functions.json
// module id = 2290
// module chunks = 231608221292675